export default __webpack_public_path__ + "static/assets/f56b90453206db164dabd6e283a1b014.png";